export default __webpack_public_path__ + "static/fargevekting-2fargekombo-25080c0fb2864e8007915437915603aa.png";